import { render, staticRenderFns } from "./ImmediateHead.vue?vue&type=template&id=4bfb47e7"
import script from "./ImmediateHead.vue?vue&type=script&lang=js"
export * from "./ImmediateHead.vue?vue&type=script&lang=js"
import style0 from "./ImmediateHead.vue?vue&type=style&index=0&id=4bfb47e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports